import { render, staticRenderFns } from "./satisPie.vue?vue&type=template&id=0cc02f6f&scoped=true&"
import script from "./satisPie.vue?vue&type=script&lang=js&"
export * from "./satisPie.vue?vue&type=script&lang=js&"
import style0 from "./satisPie.vue?vue&type=style&index=0&id=0cc02f6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc02f6f",
  null
  
)

export default component.exports